module.exports = __webpack_public_path__ + "static/media/distance-and-angle-graph.0896a495.png";